import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { TABLE_HEADER_COLOR } from '../../_config/consts';
import SortAscendingIconCustom from '../CustomIcons/SortAscendingIconCustom.jsx';
import SortDescendingIconCustom from '../CustomIcons/SortDescendingIconCustom.jsx';
import SortIconCustom from '../CustomIcons/SortIconCustom.jsx';
import UnsortIconCustom from '../CustomIcons/UnsortIconCustom.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import HypertouchDevicesEmptyState from './HypertouchDevicesEmptyState.jsx';
import OnlineStatusBadge from './OnlineStatusBadge.jsx';
import PlayingContentLabel from './PlayingContentLabel.jsx';
import { getPlayingContentSummary } from './hypertouchDeviceUtils';

const PAGE_SIZE = 10;

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableColumnHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableColumnHeaderText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableColumnHeaderArrow: {
    padding: 10,
    marginLeft: 10,
  },
  tableColumnHeaderArrowIcon: {
    fontSize: 20,
    width: 20,
  },
  tableColumnHeaderSortIcon: {
    width: 24,
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 65,
  },
});

function getSortValue(device, orderBy) {
  if (orderBy === 'applicationName') {
    const summary = getPlayingContentSummary(device.currentPlayingContent);
    return (summary.label || '').toLowerCase();
  }
  if (orderBy === 'contentType') {
    const summary = getPlayingContentSummary(device.currentPlayingContent);
    return (summary.contentType || '').toLowerCase();
  }
  if (orderBy === 'online') {
    return device.online ? 1 : 0;
  }
  const value = device[orderBy];
  return _.isString(value) ? value.toLowerCase() : value;
}

@connect(state => ({ viewLoading: state.utils.viewLoading }))
class HypertouchDevicesTableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      orderBy: 'deviceName',
      orderDir: 'ASC',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.devices !== this.props.devices) {
      this.setState({ page: 0 });
    }
  }

  handleOrderChange(column) {
    const { orderBy, orderDir } = this.state;
    const orderDirNew = orderBy === column ? (orderDir === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.setState({ orderBy: column, orderDir: orderDirNew, page: 0 });
  }

  onResetOrder() {
    this.setState({ orderBy: 'deviceName', orderDir: 'ASC', page: 0 });
  }

  onChangePage(page) {
    this.setState({ page });
  }

  renderSortHeader(column, label) {
    const { classes } = this.props;
    const { orderBy, orderDir } = this.state;

    return (
      <TableCell>
        <div className={classes.tableColumnHeader}>
          <h4 className={classes.tableColumnHeaderText}><Entity entity={label} /></h4>
          {orderBy === column ? (
            <IconButton onClick={() => this.handleOrderChange(column)} style={{ opacity: 1 }} className={classes.tableColumnHeaderArrow}>
              {orderDir === 'ASC' || orderBy !== column
                ? <SortDescendingIconCustom className={classes.tableColumnHeaderArrowIcon} />
                : <SortAscendingIconCustom className={classes.tableColumnHeaderArrowIcon} />}
            </IconButton>
          ) : (
            <IconButton onClick={() => this.handleOrderChange(column)} style={{ opacity: 0.6 }} className={classes.tableColumnHeaderArrow}>
              <SortIconCustom className={classes.tableColumnHeaderSortIcon} />
            </IconButton>
          )}
        </div>
      </TableCell>
    );
  }

  render() {
    const { classes, devices, viewLoading, selectedDevice, onSelectDevice, onRefresh, totalDevicesCount, listTop = 190 } = this.props;
    const { page, orderBy, orderDir } = this.state;
    const sortedDevices = _.orderBy(
      devices,
      [device => getSortValue(device, orderBy)],
      [orderDir === 'ASC' ? 'asc' : 'desc'],
    );
    const totalElements = sortedDevices.length;
    const totalPages = Math.max(1, Math.ceil(totalElements / PAGE_SIZE));
    const paginatedDevices = sortedDevices.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    return (
      <div className="list-view details-section" style={{ top: listTop, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(devices) ? (
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={1}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="hypertouchDevices" />
                        </h3>
                        <IconButton onClick={() => onRefresh()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                        {orderBy !== 'deviceName' || orderDir !== 'ASC' ? (
                          <IconButton onClick={() => this.onResetOrder()} style={{ marginLeft: 5, marginTop: 5 }}>
                            <UnsortIconCustom style={{ color: '#3f3f3f', width: 25 }} />
                          </IconButton>
                        ) : null}
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={5}
                      count={totalElements}
                      rowsPerPage={PAGE_SIZE}
                      page={page}
                      labelRowsPerPage=" "
                      classes={{ input: classes.disabledInput }}
                      labelDisplayedRows={() => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            entity="hypertouchDevicesTablePagination"
                            data={{
                              currentPage: page + 1,
                              totalPages,
                              count: totalElements,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, nextPage) => this.onChangePage(nextPage)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={page}
                          lastPage={totalPages - 1}
                          iconColor="#3f3f3f"
                          rowsPerPage={PAGE_SIZE}
                          onChangePage={(event, nextPage) => this.onChangePage(nextPage)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    {this.renderSortHeader('deviceName', 'name')}
                    {this.renderSortHeader('serial', 'serialNumber')}
                    {this.renderSortHeader('online', 'status')}
                    {this.renderSortHeader('applicationName', 'applicationName')}
                    {this.renderSortHeader('contentType', 'contentType')}
                    {this.renderSortHeader('osVersion', 'osVersion')}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(paginatedDevices, device => {
                    const playingContent = getPlayingContentSummary(device.currentPlayingContent);
                    return (
                      <TableRow
                        key={device.serial}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={() => onSelectDevice(device)}
                        selected={selectedDevice && selectedDevice.serial === device.serial}
                      >
                        <TableCell>
                          <div className={classes.rowContainer}>
                            <div>
                              <h5 style={{ fontWeight: 'bold', margin: 0, fontSize: 19 }}>{device.deviceName || '—'}</h5>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 15, margin: 0 }}>{device.serial || '—'}</h5>
                        </TableCell>
                        <TableCell>
                          <OnlineStatusBadge online={device.online} />
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 15, margin: 0 }}>
                            <PlayingContentLabel currentPlayingContent={device.currentPlayingContent} />
                          </h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 15, margin: 0, textTransform: 'uppercase' }}>
                            {playingContent.contentType || '—'}
                          </h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 15, margin: 0 }}>{device.osVersion || '—'}</h5>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Card>
          ) : (
            <HypertouchDevicesEmptyState viewLoading={viewLoading} totalDevicesCount={totalDevicesCount} />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(HypertouchDevicesTableView);
